import React from 'react';
import {
  IconBuilding,
  IconBuildingFactory2,
  IconDroplet,
  IconUsers,
} from '@tabler/icons-react';

const ServiceCard = ({ IconComponent, title, items }) => (
  <div className="bg-[rgba(255,244,248,1)] rounded-2xl p-5 flex flex-col gap-3">
    <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm">
      <IconComponent size={22} className="text-[#966376]" stroke={1.5} />
    </div>
    <h4 className="text-[#0B2549] font-sans font-semibold text-base">{title}</h4>
    <ul className="flex flex-col gap-1.5">
      {items.map((item, i) => (
        <li key={i} className="text-[#6D7E94] text-xs flex items-start gap-1.5">
          <span className="text-[#966376] mt-0.5 shrink-0">•</span>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const cards = [
  {
    IconComponent: IconBuilding,
    title: 'Corporate Offices',
    items: [
      'Daily janitorial services',
      'Floor care',
      'Glass cleaning',
      'Pantry management',
    ],
  },
  {
    IconComponent: IconBuildingFactory2,
    title: 'Industrial / Factory Settings',
    items: [
      'Heavy-duty cleaning',
      'Shop floor maintenance',
      'Waste management',
      'Industrial safety standards',
    ],
  },
  {
    IconComponent: IconDroplet,
    title: 'Specialized Services',
    items: [
      'Facade cleaning',
      'Pest control',
      'Carpet shampooing',
      'HVAC disinfection',
    ],
  },
  {
    IconComponent: IconUsers,
    title: 'Staffing',
    items: [
      'Site supervisors',
      'Trained cleaning crews',
      'Multi-tasking support staff',
    ],
  },
];

const FacilityManagementSection = () => (
  <section className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
    <div className="max-w-[75rem] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left: text */}
        <div className="text-center lg:text-left">
          <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase tracking-widest">
            FACILITY MANAGEMENT
          </h2>
          <h3
            style={{ lineHeight: 1.25 }}
            className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-4xl font-bold mt-3 mb-5"
          >
            Professional Facility Care<br className="hidden sm:block" /> for Every Environment
          </h3>
          <p className="text-[#6D7E94] text-sm sm:text-base font-[500] leading-relaxed max-w-lg mx-auto lg:mx-0">
            Professional housekeeping goes beyond simple cleaning — it involves maintaining
            a safe, hygienic, and aesthetically pleasing environment that reflects your
            company's brand. From daily janitorial rounds to specialized disinfection, we
            cover every corner.
          </p>
        </div>
        {/* Right: cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {cards.map((card, i) => (
            <ServiceCard key={i} {...card} />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default FacilityManagementSection;
